export enum ServiceConfirmationStyle {
  base = 'base',
  minor = 'minor',
}
